import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">最新动态</h2>
        <p className="section-subtitle">剧集更新、功能上线、口碑速报，97影视最新资讯一览</p>

        <div className="max-w-3xl mx-auto">
          {updatesData.map((item, index) => (
            <div
              key={index}
              className="flex items-start gap-4 py-3.5 border-l-2 border-primary-200 pl-5 relative group cursor-pointer hover:border-primary-500 transition-colors"
            >
              <div className="absolute left-0 top-4 w-2 h-2 rounded-full bg-primary-500 -translate-x-[5px] group-hover:scale-125 transition-transform"></div>
              <time className="flex-shrink-0 text-xs text-foreground-500 w-20 pt-0.5">{item.date}</time>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800 leading-relaxed">{item.content}</p>
                <span className="inline-block mt-1 text-xs text-primary-600 font-medium">{item.tag}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}